import * as Sentry from '@sentry/react'

export function safeStringify(x: unknown) {
	try {
		return typeof x === 'string' ? x : JSON.stringify(x)
	} catch {
		return String(x)
	}
}

export function installNonErrorRejectionProbe() {
	window.addEventListener('unhandledrejection', (event) => {
		const r = event.reason

		const msg = safeStringify(r)
		if (!(r instanceof Error)) {
			event.preventDefault()

			const err = new Error(`Non-Error rejection: ${msg}`)
			err.cause = r

			Sentry.captureException(err, {
				level: 'error',
				tags: {
					non_error_promise_rejection: 'true',
					probe: 'total-rejection',
				},
				extra: {
					rejection_raw: r,
					stack_at_probe: new Error().stack,
					url: window.location.href,
				},

				mechanism: {
					type: 'onunhandledrejection',
					handled: false,
					synthetic: true,
				} as any,
			})
		}
	})
}
